import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["code", "editorConfig", "onChange", "onInitialized"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultEditorConfig = {
  mode: 'jsx',
  tabSize: 2,
  theme: 'default'
};

function importCodeMirror() {
  return _importCodeMirror.apply(this, arguments);
}

function _importCodeMirror() {
  _importCodeMirror = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var CodeMirror;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import('codemirror').then(function (module) {
              return typeof module === 'function' ? module : module["default"];
            });

          case 2:
            CodeMirror = _context.sent;
            _context.next = 5;
            return Promise.all([import('codemirror/mode/javascript/javascript'), import('codemirror/mode/jsx/jsx'), import('codemirror/addon/runmode/runmode')]);

          case 5:
            return _context.abrupt("return", CodeMirror);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _importCodeMirror.apply(this, arguments);
}

var CodeEditor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var code = props.code,
      editorConfig = props.editorConfig,
      onChange = props.onChange,
      onInitialized = props.onInitialized,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var textareaRef = useRef(null);
  var editor = useRef(null);

  var _useState = useState(false),
      initialized = _useState[0],
      setInitialized = _useState[1];

  var handleChange = useCallback(function () {
    var _editor$current;

    onChange === null || onChange === void 0 ? void 0 : onChange((_editor$current = editor.current) === null || _editor$current === void 0 ? void 0 : _editor$current.getValue());
  }, [onChange]);
  useEffect(function () {
    importCodeMirror().then(function (CodeMirror) {
      if (!CodeMirror || !textareaRef.current) {
        return;
      }

      setInitialized(true);

      if (!editor.current) {
        editor.current = CodeMirror.fromTextArea(textareaRef.current, _extends({}, defaultEditorConfig, editorConfig));
        editor.current.on('change', handleChange);
        onInitialized === null || onInitialized === void 0 ? void 0 : onInitialized(editor.current);
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (code) {
      var _editor$current2;

      (_editor$current2 = editor.current) === null || _editor$current2 === void 0 ? void 0 : _editor$current2.setValue(code);
    }
  }, [code]);
  return /*#__PURE__*/_jsxs("div", _extends({
    ref: ref
  }, rest, {
    children: [!initialized && /*#__PURE__*/_jsx("div", {
      className: "rcv-editor-loader",
      children: "Editor initializing ..."
    }), /*#__PURE__*/_jsx("textarea", {
      ref: textareaRef,
      defaultValue: code === null || code === void 0 ? void 0 : code.trim()
    })]
  }));
});
export default CodeEditor;